import { render, staticRenderFns } from "./match-image.vue?vue&type=template&id=55f53d03&scoped=true&"
import script from "./match-image.vue?vue&type=script&lang=js&"
export * from "./match-image.vue?vue&type=script&lang=js&"
import style0 from "./match-image.vue?vue&type=style&index=0&id=55f53d03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f53d03",
  null
  
)

export default component.exports